import React, {Component} from "react";
import {Form, Input, Select, Checkbox, DatePicker} from "antd";
const { TextArea } = Input;
const { Option } = Select;

class DifferentClaimDetails extends Component{
    render (){
        return <div>
            <Form.Item
                label="Invoice Number"
                name={'invoiceNumber'}
                rules={[{ required: true}]}
            >
                <Input maxLength={10} />
            </Form.Item>
            <p style={{color:'#dc291e',marginLeft:'46%',display:this.props.InvoiceClaimMsg?'block':'none'}}>The invoice number is linked to different customer</p>
            <Form.Item
                label="Invoice Item Number"
                name={'invoiceItemNo'}
                rules={[{ required: this.props.type==3?true:false}]}
            >
                <Input />
            </Form.Item>
            {this.props.type==14?
                <Form.Item
                    label="PO Number"
                    name={'poNumber'}
                    rules={[{ required: true}]}
                >
                    <Input />
                </Form.Item>:''
            }
            {this.props.epackTypeKey==2?
                <Form.Item
                    label="DOA Period Confirmation Number"
                    name={'doaConfirmNo'}
                    rules={[{ required: true}]}
                >
                    <Input maxLength={10} />
                </Form.Item>:''
            }
            <Form.Item
                label="Part Number"
                name={'partNumber'}
                rules={[{ required: true}]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Quantity"
                name={'quantity'}
                rules={[{ required: true}]}
            >
                <Input />
            </Form.Item>
            {this.props.epackTypeKey==2 || this.props.epackTypeKey==3 || this.props.epackTypeKey==4 || this.props.type==8 || this.props.type==11?
                ''
                :
            <Form.Item
                label="Serial Number"
                name={'serialNumbers'}
                rules={[{ required: this.props.epackTypeKey==1 || this.props.type==1 || this.props.type==3 || this.props.type==4 || this.props.type==6 || this.props.type==10 || this.props.type==14?true:false}]}
            >
                <TextArea />
            </Form.Item>
            }
            {this.props.type==8 || this.props.type==10?
                <Form.Item
                label="BIOS Password"
                name={'biosPassword'}
                rules={[{ required:false}]}
                >
                    <Input maxLength={20} />
                </Form.Item>:''
            }
            {this.props.type==11?
            <div>
                <Form.Item
                    label="Price Drop Date"
                    name={'Price Drop Date'}
                    rules={[{ required: true}]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Unit Claim Value"
                    name={'creditAmountUnit'}
                    rules={[{ required: true}]}
                >
                    <Input onChange={this.props.onCreditAmountTotal} />
                </Form.Item>
            </div>
            :this.props.type==14?
                <Form.Item
                    label="Credit Amount Per Service"
                    name={'Credit Amount Per Service'}
                    rules={[{ required: false}]}
                >
                    <Input />
                </Form.Item>
                    :
                <Form.Item
                    label="Credit Amount Per Unit"
                    name={'creditAmountUnit'}
                    rules={[{ required:  this.props.type==11?true:false}]}
                >
                    <Input />
                </Form.Item>
            }
            <Form.Item
                label="Currency"
                name={'currency'}
                rules={[{ required: true }]}
            >
                <Select placeholder='Please select'>
                    {
                        this.props.currencyList.map((item)=>{
                            return <Option value={item.key} >{item.value}</Option>
                        })
                    }
                </Select>
            </Form.Item>
            {this.props.type==14?
                <div>
                    <Form.Item
                        label="Service Period Start Date"
                        name={'serviceStartDate'}
                        rules={[{ required: false}]}
                    >
                        <DatePicker />
                    </Form.Item>
                    <Form.Item
                        label="Service Period End Date"
                        name={'serviceEndDate'}
                        rules={[{ required: false}]}
                    >
                        <DatePicker />
                    </Form.Item>
                </div>:''
            }
        {/*    {this.props.type==6?*/}
        {/*    <Form.Item*/}
        {/*        label="Also Product damaged"*/}
        {/*        name={'damaged'}*/}
        {/*        rules={[{ required: false, message: 'Missing first name' }]}*/}
        {/*    >*/}
        {/*        <Checkbox></Checkbox>*/}
        {/*    </Form.Item>:''    */}
        {/*}*/}
        </div>
    }

}

export default DifferentClaimDetails;